import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/VRP.png";
import linkedin from "../assets/linkedin-sales-solutions.jpg";

const NextSteps = () => {
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem("authToken"));

  const handleNext = () => {
    if (isLoggedIn) {
      navigate("/video-platform/regions");
    } else {
      navigate("/login"); // or "/" if you prefer
    }
  };
  return (
    <main className="min-h-screen bg-white">
      {/* Blue Top Section */}
      <div className="relative">
        <img
          src={Logo}
          alt="Video Resume Platform"
          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center p-4"></div>
      </div>
      {/* Main Content Section */}
      <section className=" max-w-full mx-auto px-4 md:px-0 py-12">
        <div className="flex flex-col md:flex-row row-span-1 gap-10">
          {/* Left Column */}
          <div className="w-full md:pt-50 md:pl-20 md:w-1/4">
            <div className="bg-white text-center  transition-shadow mr-10">
              <h2 className="text-4xl font-bold text-[#003DA5] border-b-4 pb-6 border-[#FFC72C]  mb-4">
                Start Here
              </h2>
              <div className=" text-left text-[#003DA5] mb-8">
                <h3 className="font-bold text-xl">Watch VRP Tutorial</h3>
                <p className="text-md text-left text-gray-600 mt-1 -mr-10">
                  This video tutorial shares a step-by-step process of how to
                  use the Faces of Talent VRP.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="w-full md:w-3/4">
            <img
              src={linkedin}
              alt="Person using laptop"
              className="rounded-md w-full h-auto object-cover shadow-md mb-8"
            />

            {/* Section Title Below Image */}
            <p className="text-xl font-bold text-gray-700 mb-8">
              Before you jump in,{" "}
              <span className="text-[#003DA5]">let’s review the steps.</span>
            </p>

            {/* Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:pr-16 lg:grid-cols-4 lg:grid-rows-2 gap-8">
              {[
                {
                  num: "1.",
                  title: "Select your Region",
                  description:
                    "SLU TWA is located St. Louis, Kansas City, Springfield and Columbia. Choose the region that best matches your organization’s location.",
                },
                {
                  num: "2.",
                  title: "Select your Industry",
                  description:
                    "Choose your industry to view candidates with experience and interest in that field.",
                },
                {
                  num: "3.",
                  title: "Review Candidates",
                  description:
                    "Use the filters at the top to narrow or expand your search criteria. Our Offense Eligibility filter allows you to focus on  candidates who meet your company’s current background policy while supporting fair chance hiring for all others.  Our Transportation filter allows you to view candidates that can access your location.",
                },
                {
                  num: "4.",
                  title: "Review Profile",
                  description:
                    "Favorite a candidate by clicking the heart. These candidates appear in your profile, found at the top right corner of the page. Click on your profile to easily review the candidates you have selected.",
                },
                {
                  num: "5.",
                  title: "Download and Connect",
                  description:
                    "Direct contact information for each candidate is accessible on the written resume. Download the video and/or written resume by clicking the file icon on the bottom right of the participants video.",
                },
                {
                  num: "6.",
                  title: "Search by Candidate",
                  description:
                    "If you are searching for a specific candidate by name, enter their name in the Search Candidate field on the top right corner of the VRP.",
                },
              ].map((step, index) => (
                <div
                  key={index}
                  className="bg-white border-t-4 border-[#FFC72C] transition-shadow"
                >
                  <div className="mt-6 flex flex-row">
                    <div className="sm:text-base md:text-6xl font-light font-['farnham-display'] text-[#003DA5] mb-2">
                      {step.num}
                    </div>
                    <h4 className="ml-2 text-xl font-semibold mb-2 text-[#003DA5] font-['farnham-display']">
                      {step.title}
                    </h4>
                  </div>
                  <p className="text-sm font-['corporate-s']">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
              {/* CTA Box Beside Step 6 */}
              <div className="bg-[#ffc72c] px-6 py-6 md:col-start-2 text-center shadow-lg flex flex-col justify-center">
                <p className="text-[#003DA5] font-bold mb-3 text-lg">
                  I’m ready to find talent
                </p>
                <button
                  onClick={handleNext}
                  className="bg-[#003DA5] cursor-pointer hover:bg-blue-800 text-white font-bold py-3 px-8 rounded shadow-md transition duration-200"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default NextSteps;
